import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import Footer from '../Footer/Footer';

function Contact(props) {
  const sendEmail = (e) => {
    e.preventDefault();
    window.emailjs
      .sendForm(
        'default_service',
        'template_1ewbltc',
        e.target,
        'user_XOlCl0ufWTjmhLIBVREYN'
      )
      .then(
        (result) => {
          alert('Thank You. We will contact you soon')
          props.history.push("/")
        },
        (error) => {
          alert('Something went wrong. Please try after sometime')
        }
      );
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  if (1 === !1) return <Redirect to="/" />;
  return (
    <div>
      <div style={{ marginTop: '3.4em' }}>
        <div
          className="page-top-info"
          style={{
            height: '390px',
            backgroundImage: 'url(./img/contact.jpg)',
            boxShadow: '0 3px 5px rgba(0, 0, 0, 0.2)',
            backgroundSize: 'cover',
            resize: 'both',
            borderBottom: '1px solid #00000010',
            paddingBottom: '10px',
            marginBottom: 0
          }}
        ></div>
        <section className="contact-section">
          <div className="container">
            <div className="row shadow-sm" style={{ padding: '10px' }}>
              <div
                className="col-12 col-lg-6 contact-info mb-4"
                style={{ textAlign: 'left' }}
              >
                <h3 style={{ marginBottom: '0px', paddingBottom: '12px' }}>
                  Get in touch
                </h3>
                <p style={{ textAlign: 'left' }}>
                  We’re here to help and answer any question you might have. We
                  look forward to hearing from you <span role="img">🙂</span>
                </p>
                <hr style={{ paddingBottom: '4px' }} />
                <p>
                  <i
                    className="fa fa-map-marker"
                    style={{ paddingRight: '10px' }}
                  ></i>{' '}
                  39 Wentworth Road Strathfield NSW 2135
                </p>
                <p>
                  <i
                    className="fa fa-phone"
                    style={{ paddingRight: '10px' }}
                  ></i>{' '}
                  +61 451 903 785
                </p>
                <p>
                  <i
                    className="fa fa-envelope"
                    style={{ paddingRight: '10px' }}
                  ></i>{' '}
                  team@grospick.com
                </p>
              </div>
              <div className="col-12 col-lg-4 offset-lg-2">
                <h3 style={{ marginBottom: '0px', paddingBottom: '12px' }}>
                  Other ways to connect
                </h3>
                <div
                  className="contact-social "
                  style={{ justifyContent: 'center' }}
                >
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.instagram.com/grospicker/?hl=en"
                  >
                    <i className="fa fa-instagram" />
                  </a>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.facebook.com/Grospick-108163027510472/"
                    style={{ marginRight: '20px', textDecoration: 'none' }}
                  >
                    <i className="fa fa-facebook" />
                  </a>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://twitter.com/grospick"
                    style={{ marginRight: '20px', textDecoration: 'none' }}
                  >
                    <i className="fa fa-twitter" />
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="//#endregion"
                    style={{ marginRight: '20px', textDecoration: 'none' }}
                  >
                    <i className="fa fa-linkedin" />
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="//#endregion"
                    style={{ marginRight: '20px', textDecoration: 'none' }}
                  >
                    <i className="fa fa-whatsapp" />
                  </a>
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <form className="contact-form" onSubmit={sendEmail}>
                  <input
                    type="text"
                    name="user_name"
                    placeholder="Your Fullname"
                  />
                  <input
                    type="text"
                    name="contact_number"
                    placeholder="Your Phone Number"
                  />
                  <input
                    type="email"
                    name="user_email"
                    placeholder="Your E-mail"
                  />
                  <input type="text" name="subject" placeholder="Subject" />
                  <textarea
                    placeholder="Message"
                    name="message"
                    defaultValue={''}
                  />
                  <button
                    type="submit"
                    style={{
                      height: '45px',
                      paddingTop: '12px',
                      background: 'rgb(1, 160, 90)',
                      border: '1px solid rgb(1, 160, 90)',
                      color: '#fff',
                      borderRadius: '15px',
                    }}
                    className="btnAdd site-btn"
                  >
                    SEND NOW
                  </button>
                </form>
              </div>
              <div className="map col-12 col-lg-6" style={{ height: '30em' }}>
                <iframe
                  title="contact"
                  src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14376.077865872314!2d-73.879277264103!3d40.757667781624285!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sbd!4v1546528920522"
                  style={{ border: 0 }}
                  allowFullScreen
                />
              </div>
            </div>
          </div>
        </section>
        <br /> <br />
        <Footer />
      </div>
    </div>
  );
}
export default Contact;
